export default {
  "notifications.title": "الإشعارات",
  "notifications.subtitle": "مستجدات الطلبات والتقييمات وسجل الإشعارات السابقة",
  "notifications.all": "عرض جميع الإشعارات",
  "notifications.refresh": "تحديث",
  "notifications.listTitle": "سجل الإشعارات",

  "notifications.empty": "لا توجد إشعارات بعد",
  "notifications.emptyDesc": "ستظهر هنا مستجدات الطلبات والتقييمات",
  "notifications.error": "تعذّر تحميل الإشعارات",
  "notifications.targetMissing": "تعذر الوصول إلى العنصر المرتبط بهذا الإشعار",
  "notifications.noDestination": "هذا الإشعار للاطلاع فقط ولا يفتح صفحة مرتبطة.",

  "notifications.orderRef": "رقم الطلب",
  "notifications.openOrder": "عرض الطلب",
  "notifications.openReviews": "عرض التقييمات",
  "notifications.openDriverReviews": "تقييمات المندوب",

  "notifications.processed": "تمت معالجته",
  "notifications.markProcessed": "تمييز كمعالج",
  "notifications.unmarkProcessed": "إلغاء التمييز",
  "notifications.markAllProcessed": "تمييز الكل كمعالج",

  "notifications.filter.all": "الكل",
  "notifications.filter.unprocessed": "قيد المتابعة",
  "notifications.filter.processed": "تمت معالجتها",
  "notifications.filter.empty": "لا توجد إشعارات مطابقة",
  "notifications.filter.emptyDesc": "اختر تصنيفًا آخر لعرض الإشعارات.",

  "notifications.note": "تُعرض هنا آخر الإشعارات الواردة إلى لوحة المغسلة. يمكنك تمييز الإشعار كمعالج لمتابعة سجل المتبقي.",
  "notifications.live.demo": "معاينة وصول إشعار فوري",
  "notifications.live.demoHint": "زر تجريبي لاستعراض وصول إشعار فوري في المعاينة فقط.",

  "notifications.type.new_order.title": "طلب جديد يحتاج قرارك",
  "notifications.type.new_order.body": "وصل الطلب {{orderId}} وينتظر القبول أو الرفض",
  "notifications.type.new_order.bodyGeneric": "وصل طلب جديد وينتظر القبول أو الرفض",

  "notifications.type.order_handoff.title": "تم تسليم الطلب إلى المغسلة",
  "notifications.type.order_handoff.body": "أكد المندوب تسليم الطلب {{orderId}} إلى المغسلة",
  "notifications.type.order_handoff.bodyGeneric": "أكد المندوب تسليم الطلب إلى المغسلة",

  "notifications.type.manual_assignment.title": "طلب يحتاج تعيين مندوب",
  "notifications.type.manual_assignment.body": "اختار العميل الانتظار وانقضت المهلة دون قبول مهمة تسليم الطلب {{orderId}}",
  "notifications.type.manual_assignment.bodyGeneric": "اختار العميل الانتظار وانقضت المهلة دون قبول مهمة التسليم",

  "notifications.type.new_review.title": "تقييم جديد من عميل",
  "notifications.type.new_review.bodyBoth": "ترك {{customerName}} تقييمًا بقيمة {{rating}} من 5",
  "notifications.type.new_review.bodyName": "وصلك تقييم جديد من {{customerName}}",
  "notifications.type.new_review.bodyRating": "وصلك تقييم جديد بقيمة {{rating}} من 5",
  "notifications.type.new_review.bodyGeneric": "وصلك تقييم جديد من عميل",

  "notifications.type.package_subscription.title": "اشتراك جديد في باقة",
  "notifications.type.package_subscription.bodyBoth": "اشترك {{customerName}} في {{packageName}}",
  "notifications.type.package_subscription.bodyName": "اشترك {{customerName}} في باقة",
  "notifications.type.package_subscription.bodyPackage": "اشتراك جديد في {{packageName}}",
  "notifications.type.package_subscription.bodyGeneric": "ورد إشعار باشتراك عميل في باقة",

  "notifications.live.alertDemo": "معاينة تنبيه سريع",

  "notifications.alert.viewOrder": "عرض الطلب",
  "notifications.alert.dismiss": "إغلاق التنبيه",

  "notifications.alert.assignment_needed.title": "طلب يحتاج تعيين مندوب",
  "notifications.alert.assignment_needed.body": "انقضت مهلة الانتظار للطلب {{orderId}} دون قبول مهمة التسليم — يلزم التعيين اليدوي الآن",
  "notifications.alert.assignment_needed.bodyGeneric": "انقضت مهلة الانتظار دون قبول مهمة التسليم — يلزم التعيين اليدوي الآن",

  "notifications.alert.driver_issue.title": "مشكلة مع المندوب",
  "notifications.alert.driver_issue.body": "تعذّر إكمال مهمة الطلب {{orderId}} من قِبل المندوب — راجع الطلب وأعد التعيين",
  "notifications.alert.driver_issue.bodyGeneric": "تعذّر إكمال مهمة المندوب — راجع الطلب وأعد التعيين",

  "notifications.alert.delay.title": "تأخر في التسليم",
  "notifications.alert.delay.body": "تجاوز تسليم الطلب {{orderId}} الوقت المتوقع — تابع المهمة",
  "notifications.alert.delay.bodyGeneric": "تجاوز التسليم الوقت المتوقع — تابع المهمة",

  "notifications.alert.new_order.title": "طلب جديد وصل",
  "notifications.alert.new_order.body": "وصل الطلب {{orderId}} وينتظر القبول أو الرفض",
  "notifications.alert.new_order.bodyGeneric": "وصل طلب جديد وينتظر القبول أو الرفض"
};